module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Italic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Italic.ttf
// module id = 1897
// module chunks = 0